<template>
  <div class="box">
    <div class="nodata">
      <img src="../../assets/images/nonelist.png" alt="">
      <p>暂无更多</p>
    </div>
  </div>

</template>

<script>
    export default {
        name: "Activity",
        data(){
            return {

            }
        },
        mounted() {

        },
        methods:{

        },
    }
</script>

<style scoped lang="scss">
  .box{
    min-height:100vh;
    background: #F7F7F7;
  }
  .nodata{
    font-size: 0.32rem;
    color: #666666;
    text-align: center;
    img{
      width:4.5rem;
      margin-top: 0.4rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Activity/inedx.vue